import fetchModels from "@/mixin/store/api/fetchModels";

export default {
    actions: {
        fetchProductInIkpuByBarcode(context, barcode) {
            return fetchModels(context, 'ikpus?barcode=' + barcode, null, 'updateIkpu', true)
        },
        searchProductFromUNEC(context, data) {

            let url = data.url + data.barcode + '&page=0&size=10'

            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest()
                xhr.open('GET', url)
                xhr.send()
                xhr.responseType = 'json'
                xhr.onload = () => {
                    if (xhr.readyState === 4 && xhr.status === 200) {

                        if (xhr.response.data.length === 1) {
                            context.commit('updateUNEC', xhr.response.data[0])
                        } else {
                            context.commit('updateUNEC', null)
                        }

                        resolve()
                    } else {
                        console.log(`Error: ${xhr.status}`)
                        reject()
                    }
                }
            })

        }
    },
    mutations: {
        updateIkpu(state, data) {
            state.ikpu = data
        },
        updateUNEC(state, data) {
            state.unec = data
        },
    },
    state: {
        ikpu: null,
        unec: null
    },
    getters: {
        getIkpu(state) {
            return state.ikpu
        },
        getUNEC(state) {
            return state.unec
        }
    }
}